import { render, staticRenderFns } from "./GenericSampleTypeCard.vue?vue&type=template&id=fba7ff58"
import script from "./GenericSampleTypeCard.vue?vue&type=script&lang=js"
export * from "./GenericSampleTypeCard.vue?vue&type=script&lang=js"
import style0 from "./GenericSampleTypeCard.vue?vue&type=style&index=0&id=fba7ff58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports